import React, { CSSProperties } from 'react';
import { useMobile } from '../hook/usePlatform';
import {
  FontWeightType, HeadingLarge, LabelLarge,
} from './Text';

interface ChangeIntroSectionType {
  title: string,
  content: string,
  contentStyle?:CSSProperties
}

const IntroSection: React.FC<ChangeIntroSectionType> = (props: ChangeIntroSectionType) => {
  const isMobile = useMobile();

  return (
    <div style={{ height: '40vh', width: '100%' }}>
      <div style={{
        paddingInline: 35,
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: isMobile ? '1px solid #979593' : '',
      }}
      >
        <HeadingLarge
          fontWeight={FontWeightType.w800}
          style={{
            letterSpacing: '0.5rem',
            color: '#333333',
            paddingBlock: 4,
          }}
        >
          {props.title}
        </HeadingLarge>
        <LabelLarge style={{
          color: '#333333',
          textAlign: 'center',
          ...props.contentStyle,
        }}
        >
          {props.content}
        </LabelLarge>
      </div>
    </div>
  );
};
export default IntroSection;
